import { render, staticRenderFns } from "./LsaAccountAlertsNotice.vue?vue&type=template&id=72c33fcc"
import script from "./LsaAccountAlertsNotice.vue?vue&type=script&lang=js"
export * from "./LsaAccountAlertsNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports